const AUTOCOMPLETE_EVENTS = window.theme.autocomplete.events

class AutocompleteStateLayer {
  constructor () {
    this.eventBus = window.theme.autocomplete.eventBus

    this.state = {
      activeTerm: '',
      fetching: false,
      products: { hits: [], total: 0 },
      popularSearches: JSON.parse(
        sessionStorage.getItem('search-dropdown-initial-responsev2'),
      )?.popularSearches || { hits: [] },
      recentSearches:
        JSON.parse(sessionStorage.getItem('search-dropdown-initial-responsev2'))
          ?.recentSearches || [],
      keywords: JSON.parse(
        sessionStorage.getItem('search-dropdown-initial-responsev2'),
      )?.keywords || { hits: [] },
      categories: { hits: [] },
    }

    this.subscribeToEvents()

    if (!sessionStorage.getItem('search-dropdown-initial-responsev2')) {
      this.eventBus.publish(AUTOCOMPLETE_EVENTS.UI.QUERY_UPDATED, { query: '' })
    } else {
      this.broadcast()
    }
  }

  saveInitialResponseToSessionStorage (response) {
    const storageKey = 'search-dropdown-initial-responsev2'
    const existing = JSON.parse(sessionStorage.getItem(storageKey)) || {}

    const dataToStore = {
      activeTerm: response.query || '',
      keywords: response.keywords.hits || [],
      products: response.products?.hits || [],
      categories: response.categories?.hits || [],
      popularSearches: response.popularSearches?.hits || [],
      recentSearches: existing.recentSearches ?? this.state.recentSearches,
    }

    try {
      sessionStorage.setItem(storageKey, JSON.stringify(dataToStore))
    } catch (error) {
      console.warn(
        'Failed to save initial search response to sessionStorage:',
        error,
      )
    }
  }

  subscribeToEvents () {
    this.eventBus.subscribe(
      AUTOCOMPLETE_EVENTS.UI.QUERY_UPDATED,
      this.onQueryUpdated.bind(this),
    )
    this.eventBus.subscribe(
      AUTOCOMPLETE_EVENTS.API.QUERY_FETCHED,
      this.onQueryFetched.bind(this),
    )
    this.eventBus.subscribe(
      AUTOCOMPLETE_EVENTS.API.FETCH_FAILED,
      this.onFetchFailed.bind(this),
    )
  }

  onQueryUpdated (data) {
    this.state.activeTerm = (data && data.query) || ''

    this.eventBus.publish(
      AUTOCOMPLETE_EVENTS.API.ACTIVE_TERM_UPDATED,
      this.state.activeTerm,
    )

    if (!this.state.activeTerm) {
      this.state.fetching = false
      this.state.products = { hits: [], total: 0 }
      this.state.categories = { hits: [] }
      this.broadcast()
    } else {
      this.state.fetching = true
      this.state.products = { hits: [], total: 0 }
      this.state.categories = { hits: [] }
    }
  }

  async onQueryFetched (response) {
    this.state.fetching = false
    this.state.keywords =
      response.keywords?.hits?.length > 0
        ? response.keywords
        : this.state.keywords
    this.state.categories = response.categories?.hits || []
    this.state.popularSearches = response.popularSearches?.hits || []

    if (response.products?.hits.length > 0) {
      const products = response.products || { hits: [], total: 0 }

      let storeDefaultCurrency = 'GBP'

      if (window.Shopify.shop === 'oh-polly-us.myshopify.com') {
        storeDefaultCurrency = 'USD'
      }

      if (window.Shopify.shop === 'oh-polly-au.myshopify.com') {
        storeDefaultCurrency = 'AUD'
      }

      if (window.Shopify.shop === 'oh-polly-ae.myshopify.com') {
        storeDefaultCurrency = 'AED'
      }

      let normalized = response.products?.hits

      if (window.Shopify.currency.active !== storeDefaultCurrency) {
        normalized = await this.updateWithShopifyPrices(normalized)
      }

      products.hits = normalized
      this.state.products = products
    }

    this.broadcast()

    if (this.state.activeTerm === '') {
      this.saveInitialResponseToSessionStorage(response)
    }
  }

  onFetchFailed () {
    this.state.fetching = false
    this.state.products = { hits: [], total: 0 }
    this.state.keywords = { hits: [] }
    this.state.categories = { hits: [] }

    this.broadcast()
  }

  broadcast () {
    this.eventBus.publish(AUTOCOMPLETE_EVENTS.STATE.RESPONSE_UPDATED, {
      activeTerm: this.state.activeTerm,
      fetching: this.state.fetching,
      products: this.state.products,
      keywords: this.state.keywords,
      categories: this.state.categories,
      recentSearches: this.state.recentSearches,
      popularSearches: this.state.popularSearches,
    })
  }

  async updateWithShopifyPrices (hits) {
    const results = await Promise.allSettled(
      hits.map(hit => {
        const handle = hit.url
          ?.split('?')[0]
          .split('/')
          .pop()
        return handle
          ? window.BAO.utils.fetchProductData(handle)
          : Promise.reject(new Error('missing handle'))
      }),
    )

    return hits.map((hit, i) => {
      const settled = results[i]
      if (settled.status !== 'fulfilled') return hit

      const data = settled.value?.product
      if (!data) return hit

      const priceCents = data.price ?? data.variants?.[0]?.price
      const compareCents =
        data.compare_at_price ?? data.variants?.[0]?.compare_at_price

      if (priceCents == null) return hit

      return {
        ...hit,
        price: priceCents,
        listPrice: compareCents,
      }
    })
  }
}

// Initialize and attach to window for debugging
window.theme.autocomplete.stateLayer = new AutocompleteStateLayer()
